// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import './assets/iconfont/iconfont.css';
import './assets/theme/index.css';
import './assets/theme/custom-variables.scss';
import './assets/iconfont/iconfont.js';
import App from './App'
import router from './router'
import store from './store'
import 'babel-polyfill';
import axiosUtil from './util/axiosUtil.js'
import { format } from 'timeago.js'
import vRegion from 'v-region';
Vue.use(vRegion);

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$axiosUtil = axiosUtil;

//计算时间，类似于几分钟前，几小时前，几天前等
Vue.filter('timeAgoLength', function (val) {
  return format(val, 'zh_CN');
})
//截取字符串(返回:0-val.length-len) 长度的字符串
Vue.filter('substring', function (val,len) {
  let ret = val;
  if(val&&len){
    if(typeof val=='string'){
      if(val.length>Number(len)){
        ret = val.substr(0,val.length-len);
      }
    }
  }
  return ret;
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js